(function() {
    'use strict';

    angular
        .module('quantixApp')
        .controller('SessionTimeOut', SessionTimeOut);

    SessionTimeOut.$inject = ['$uibModalInstance'];

    function SessionTimeOut ($uibModalInstance) {
        var vm = this;
        vm.clear=clear;
       function clear(){
    	   $uibModalInstance.dismiss(true);
       }
    }
})();
